import { createContext } from "react"

export const InvestmentsContext = createContext<{
	search: string
	setSearch: (search: string) => void
}>(null!)
